import React from 'react';
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Rating,
} from '@mui/material';
import { Comment as CommentIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

const UserFeedback = ({ userFeedbacks }) => {
  return (
    <Paper
      sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Typography
        variant="h6"
        gutterBottom
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <CommentIcon sx={{ mr: 1 }} />
        User Feedback
      </Typography>

      {userFeedbacks.length > 0 ? (
        <List sx={{ flex: 1, maxHeight: 400, overflow: 'auto', mt: 1 }}>
          {userFeedbacks.map(feedback => (
            <ListItem key={feedback.id} sx={{ px: 0, py: 1 }}>
              <ListItemAvatar>
                <Avatar sx={{ width: 32, height: 32, fontSize: '0.875rem' }}>
                  {feedback.user.charAt(0).toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Typography variant="subtitle2">{feedback.user}</Typography>
                    <Rating value={feedback.rating} readOnly size="small" />
                  </Box>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {feedback.comment}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {new Date(feedback.timestamp).toLocaleDateString()}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Box
          textAlign="center"
          py={4}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No feedback yet. Be the first to rate this template!
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

UserFeedback.propTypes = {
  userFeedbacks: PropTypes.array.isRequired,
};

export default UserFeedback;
